import React, { useState } from "react";
import { Button } from "react-bootstrap";
import { defineMessages, injectIntl } from "react-intl";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { far } from "@fortawesome/pro-regular-svg-icons";
import PropTypes from "prop-types";
import useUserAccount from "../hooks/useUserAccount";
import useEnv from "../hooks/useEnv";

const messages = defineMessages({
    current_account: {
        id: "Nykyinen tili",
        defaultMessage: "Current account"
    },
    switch_company: {
        id: "Vaihda yritystiliä",
        defaultMessage: "Switch account"
    },
    switch_company_info: {
        id: "Sinut ohjataan Suomi.fi-palveluun valitsemaan toinen organisaatio.",
        defaultMessage: "You will be redirected to Suomi.fi to select another organisation."
    },
    switch_company_error: {
        id: "Tapahtui virhe. Ole hyvä ja yritä uudelleen.",
        defaultMessage: "An error occurred. Please try again."
    }
});

const MenuCompanySelect = (props) => {
    const { userCompanyName, userInitCompanyAuthentication } = useUserAccount();
    const { isDev } = useEnv();
    const [expanded, setExpanded] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    const lng = props.intl.formatMessage;

    const handleCompanyChange = async () => {
        if (loading) return;
        setLoading(true);
        setError(false);
        try {
            const url = await userInitCompanyAuthentication();
            if (url !== null) {
                window.location.replace(url);
            } else {
                setLoading(false);
                setError(true);
            }
        } catch (e) {
            setLoading(false);
            setError(true);
            if (isDev) {
                console.error('Company auth init failed', e);
            }
        }
    };

    return (
        <div className="menu-company-select">
            <button
                type="button"
                className="menu-company-toggle"
                onClick={() => setExpanded(prev => !prev)}
                aria-expanded={expanded}
                aria-controls="menu-company-expanded"
            >
                <div className="menu-company-toggle-content">
                    <span className="menu-company-label">{lng(messages.current_account)}</span>
                    <span className="menu-company-name">{userCompanyName()}</span>
                </div>
                <FontAwesomeIcon icon={expanded ? far.faChevronUp : far.faChevronDown} />
            </button>
            {expanded && (
                <div id="menu-company-expanded" className="menu-company-expanded">
                    <Button variant="outline-primary" className="w-100 menu-company-switch-btn" onClick={handleCompanyChange} disabled={loading}>
                        {lng(messages.switch_company)}
                    </Button>
                    <p className="menu-company-helper">{lng(messages.switch_company_info)}</p>
                    {error && (
                        <p className="menu-company-error text-danger" role="alert">
                            {lng(messages.switch_company_error)}
                        </p>
                    )}
                </div>
            )}
        </div>
    );
};

MenuCompanySelect.propTypes = {
    intl: PropTypes.object.isRequired
};

export default injectIntl(MenuCompanySelect);
